module.exports = __webpack_public_path__ + "static/media/BGPG3@2x.68dc8e9c.png";